import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-planificado',
  templateUrl: './planificado.component.html',
  styleUrls: ['./planificado.component.css']
})
export class PlanificadoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
